import { defaultApiState } from '../api.state';

export const appointmentState = {
  apiState: {
    getAppointments: defaultApiState,
    getAppointment: defaultApiState,
    updateAppointment: defaultApiState,
  },
  appointments: [],
  appointment: undefined,
};
